import { gettext } from '@resuelve/malinchex';
import { i18nTexts } from '../i18n';

export function MeetingDetailsScreen({
  participantName,
  setParticipantName,
  onJoin
}) {

  const canJoin = participantName.trim().length >= 3;

  return (
    <div
      className={`flex flex-1 flex-col justify-center w-full md:p-[6px] sm:p-1 p-1.5`}
    >
      <input
        value={participantName}
        onChange={(e) => setParticipantName(e.target.value)}
        placeholder={gettext(i18nTexts.joining_screen.name_input)}
        className="px-4 py-3 mt-5 bg-gray-650 rounded-xl text-white w-full text-center"
      />
      <button
        disabled={!canJoin}
        className={`w-full ${
          !canJoin ? "bg-purple_marguerite-50" : "bg-purple_marguerite-600"
        }  ${!canJoin ? "text-purple-900" : "text-white" } px-2 py-3 rounded-xl mt-5`}
        onClick={async () => {
          onJoin?.();
        }}
      >
        {gettext(i18nTexts.joining_screen.button)}
      </button>
      <p className="md:text-base text-sm text-white mt-4 text-center md:text-left font-semibold">
        {gettext(i18nTexts.joining_screen.terms_and_conditions)}
      </p>
      <p className="md:text-sm text-xs text-yellow-300 text-center md:text-left font-medium mt-2">
        {gettext(i18nTexts.joining_screen.mic_cam_notice)}
      </p>
    </div>
  );
}
